import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=31a606ae&scoped=true&"
import script from "./HeaderMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=31a606ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a606ae",
  null
  
)

export default component.exports